module.exports = __webpack_public_path__ + "static/media/skill-3.96d65a61.svg";